import { app } from '../../../../../app';
import { Controller } from './import-result.controller';

app.component('userPasswordManagerImportResult', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./import-result.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/import/import-result/import-result.component.js